import React from "react";
import "./styles.less";

export const CardTwo = (props) => {
  const { title, icon, adress } = props;
  const enterPage = (adress) => {
    window.open(adress);
  };
  return (
    <>
      <div className="card-two">
        <div className="content-box">
          <div className="card-icon">{icon}</div>
          <div
            className="content"
            onClick={() => {
              enterPage(adress);
            }}
          >
            <div className="title">{title}</div>
            {/* <div className="links">
              {links &&
                links.map((item) => {
                  return (
                    <div
                      className="link-item"
                      onClick={() => {
                        enterPage(item.adress);
                      }}
                    >
                      {item.text}
                    </div>
                  );
                })}
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
